import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chamili';
const args = {};

export class Chamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
